import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// Modules
import {
	AbstractModal,
	BroadcastService,
	ModalButtonModel,
	ModalButtonType,
	ToasterType
} from '@cv-invision/core';
// Service
import { SoftwareCollectorPackagesService } from '../../service/software-collector-packages.service';
// Modle
import {
	SoftwareCollectorPackageModel,
	AssignTo,
	AssignToList,
	AccessLevel,
	AccessLevelList
} from '../model/software-collector-packages.model';

@Component({
	selector: 'cv-invision-create-update-software-collector-package',
	templateUrl: './create-update-package.component.html',
	styleUrls: ['./create-update-package.component.scss']
})
export class CreateUpdatePackageComponent extends AbstractModal implements OnInit, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();

	packageData: SoftwareCollectorPackageModel;
	saving: boolean;
	insideMapsList: Array<any>;
	assignToSelected: AssignTo;
	accessLevelSelected: AccessLevel;
	assignToList: Array<any>;
	accessLevelList: Array<any>;

	constructor(
		private softwareCollectorService: SoftwareCollectorPackagesService,
		private broadcastService: BroadcastService
	) {
		super();
		this.packageData = new SoftwareCollectorPackageModel();
		this.saving = false;
		this.assignToSelected = new AssignTo();
		this.accessLevelSelected = new AccessLevel();
		this.assignToList    = AssignToList;
		this.accessLevelList = AccessLevelList;
	}

	ngOnInit(): void {

		if (this.data.isEditing) {
			this.softwareCollectorService
				.getPackageById(this.data.insideMapsId)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(response => {
				this.packageData = response;

				const assignedTo = AssignToList.filter(
					assignTo => assignTo.id === this.packageData.assignedTo
				);
				if (assignedTo.length) {
					this.assignToSelected = assignedTo[0];
				}

				const accessLevel = AccessLevelList.filter(
					level => level.id === this.packageData.accessLevel
				);

				if (accessLevel.length) {
					this.accessLevelSelected = accessLevel[0];
				}
			});
		} else {
			this.packageData.active = true;
		}

		const cancelButton: ModalButtonModel = {
			name: 'close',
			text: 'Close',
			class: 'btn-sm',
			type: ModalButtonType.ACTION,
			action: this.onCancel.bind(this)
		};
		const confirmButton: ModalButtonModel = {
			name: 'save',
			text: 'Save',
			class: 'btn-sm cv-btn-blue ',
			type: ModalButtonType.ACTION,
			disabled: (): boolean => !this.setIsFormValid() || this.saving,
			action: () => this.onSave(),
			loading: (): boolean => this.saving,
			loadingText: 'Saving'
		};

		this.buttons.push(cancelButton);
		this.buttons.push(confirmButton);
	}

	/**
	 * On Save button.
	 */
	onSave(): void {
		if (this.data.isEditing) {
			this.softwareCollectorService
				.updatePackage(this.data.insideMapsId, this.packageData)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(
				response => {
					if (response.succeeded) {
						this.successHandleFunction();
						super.onAcceptSuccess({
							success: true
						});
					}
				},
				error => {
					this.errorMsgFunction(error.error.error);
				}
			);
		} else {
			this.softwareCollectorService
				.setNewPackage(this.packageData)
				.pipe(takeUntil(this.atComponentDestroy))
				.subscribe(
				response => {
					if (response.succeeded) {
						this.successHandleFunction();
						super.onAcceptSuccess({
							success: true
						});
					}
				},
				error => {
					this.errorMsgFunction(error.error.error);
				}
			);
		}
	}

	/**
	 * set value for
	 * @param $event
	 */
	activateInsideMaps($event: any): void {
		this.packageData.active = $event;
	}

	/**
	 * Select assign to
	 * @param $event
	 */
	onAssignToSelected($event: any): void {
		this.packageData.assignedTo = $event ? $event.id : null;
	}

	/**
	 * Select Access Level
	 * @param $event
	 */
	onAccessLevelSelected($event: any): void {
		this.packageData.accessLevel = $event ? $event.id : null;
	}

	/**
	 * handle response from server
	 */
	successHandleFunction(): void {
		const msgSuget = this.data.isEditing ? 'Updated' : 'Created';
		const msg = `The Package Configuration was ${msgSuget} successfully`;
		this.broadcastService.broadcast({
			name: ToasterType.SUCCESS,
			event: { message: msg }
		});
	}

	/**
	 * Display error message if the operation was not success
	 * @param error
	 */
	errorMsgFunction(error: string): void {
		this.broadcastService.broadcast({
			name: ToasterType.ERROR,
			event: { error }
		});
	}

	/**
	 * Is form valid?
	 */
	setIsFormValid(): boolean {
		if (this.packageData.title &&
			this.packageData.assignedTo &&
			this.packageData.packageName &&
			this.packageData.accessLevel) {
			return true;
		} else {
			return false;
		}
	}

	onDismiss(): void {
		super.onCancel();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
